import ComparePage from './CompareLayout';
import { CAYDA, ADV } from './caydaFacts';

const VsUsersnap = () => (
  <ComparePage
    slug="usersnap"
    competitor="Usersnap"
    description="Usersnap alternative: Cayda pins feedback on your live site with no page view caps, guest access on a $14 tier instead of $189, and a free plan."
    hero="The Usersnap alternative without page view caps or a $189 tier."
    intro="Usersnap meters your page views, sells seats in blocks, and keeps two way Jira sync and client access on a $189 plan. Cayda never counts a visitor, bills only the people who accept an invite, and puts Jira, Asana, Linear and free guest access on a $14 base fee."
    verdict={[
      { label: 'Starting price', cayda: '$9/mo', other: '$49/mo' },
      { label: 'Free plan', cayda: 'No expiry', other: '20 feedback items' },
      { label: 'Page views', cayda: 'Unmetered', other: '100,000/mo on Starter' },
      { label: 'Client access', cayda: '$14 tier, guests free', other: '$189 tier' },
    ]}
    advantages={[
      { ...ADV.pricing, body: 'A base fee covers you; each accepted teammate is $5 to $6. Cayda never meters page views, because the script only activates for authenticated team members. A site with a million visitors costs the same as a site with ten.' },
      ADV.invisible,
      { ...ADV.dashboard, body: 'Kanban and list views, filters by status, priority, assignee and note type, bulk actions, threaded comments, an activity feed and CSV export on Pro. Guests you invite on Team see status without a seat.' },
      ADV.capture,
    ]}
    cost={{
      note: 'Cayda: annual billing, per month. Usersnap: figures as shown on usersnap.com/pricing with the yearly option selected, September 2026.',
      scenarios: [
        { label: 'Solo freelancer', detail: 'unlimited sites', cayda: 9, other: 49, caydaPlan: 'Pro, owner covered', otherPlan: 'Starter, 5 projects' },
        { label: 'Team of five, Slack', detail: 'status, priority, assignment, CSV', cayda: CAYDA.proPrice(4), other: 49, caydaPlan: 'Pro + 4 members', otherPlan: 'Starter, 100k views' },
        { label: 'Team of five, Jira sync + client access', detail: 'plus Asana, Linear, screen recording', cayda: CAYDA.teamPrice(4), other: 189, caydaPlan: 'Team + 4 members', otherPlan: 'Professional' },
      ],
    }}
    features={{
      note: 'Cayda plan names in the Cayda column. Usersnap details from usersnap.com/pricing, September 2026.',
      rows: [
        ['Free plan', CAYDA.free, '20 feedback items, then upgrade'],
        ['Entry paid plan', CAYDA.pro, '$49 · 5 seats · 5 projects'],
        ['Jira two way sync', CAYDA.team, 'Professional ($189)'],
        ['Page view caps', 'None', '100k to 2M per month'],
        ['Websites / projects on paid plans', 'Unlimited', '5 / 15 / 20 / 50'],
        ['Visible to site visitors', 'Never', 'Feedback button'],
        ['Runs on your live domain', true, true],
        ['Auto screenshot, browser, OS, viewport', true, true],
        ['Screen recording', 'Team', 'All plans'],
        ['Kanban + list dashboard, bulk actions', true, 'Kanban board'],
        ['Client / guest reviewers', 'Team, no member fee', 'Professional ($189)'],
        ['CSV export', 'Pro', 'Yes'],
        ['WordPress plugin, Shopify app', true, 'Browser extension'],
      ],
    }}
    approach={[
      'Usersnap is aimed at product organisations: a feedback button for end users, micro-surveys, in-app announcements, an AI assistant, and enterprise tiers with SSO. Plans are defined by seats, projects and monthly page views, from 5 seats and 100,000 views on Starter to 50 seats and 2,000,000 views on Premium, with two way tracker sync and the guest board on the $189 Professional plan.',
      'Cayda is a website feedback tool for the team that owns the site. There is nothing to meter because visitors never load the layer, there is no seat block because members bill individually, and the tracker and client access features live on a $14 base fee.',
    ]}
    bottomLine={[
      'For a team reviewing its own sites and web apps, Cayda delivers the pinned notes, the triage board, the tracker integrations and the client access for a fraction of the price, with no page view meter and nothing on the page for your visitors. Start free on two sites.',
    ]}
  />
);

export default VsUsersnap;
